/**
 * Returns a suggested name for a duplicated snippet.
 * - If currentName ends with optional space(s) + number (e.g. "Snippet 2", "Snippet 10"), increment the number (e.g. "Snippet 3").
 * - Otherwise append " 2" so the next duplicate will fall under the first case.
 */
export const getSuggestedDuplicateName = (currentName: string): string => {
	const trimmed = currentName.trim();
	if (!trimmed) {
		// If the name is empty, leave as is
		return currentName;
	}
	// Match "prefix" + space(s) + trailing number (e.g. "Snippet 2")
	const match = trimmed.match(/^(.+?)\s+(\d+)$/);
	if (match) {
		const prefix = match[1];
		const num = match[2];
		return `${prefix} ${parseInt(num, 10) + 1}`;
	}
	return `${trimmed} 2`;
};
